import store from '../store'

export default {
  padDate: function (val) {
    let va = val < 10 ? '0' + val : val;
    return va
  },
  // toTreeData:function(data,attributes) {
  //   let pos = {};
  //   let tree = [];
  //   let i = 0;
  //   while (data.length != 0) {
  //     debugger
  //     if (data[i][attributes.pId] == '0') {
  //       tree.push({
  //         id: data[i][attributes.id],
  //         label: data[i].name,
  //         ...data[i],
  //         children: []
  //       });
  //       pos[data[i][attributes.id]] = [tree.length - 1];
  //       data.splice(i, 1);
  //       i--;
  //     } else {
  //       let posArr = pos[data[i][attributes.pId]];
  //       if (posArr != undefined) {

  //         let obj = tree[posArr[0]];
  //         for (let j = 1; j < posArr.length; j++) {
  //           obj = obj.children[posArr[j]];
  //         }

  //         obj.children.push({
  //           id: data[i][attributes.id],
  //           label: data[i].name,
  //           ...data[i],
  //           children: []
  //         });
  //         pos[data[i][attributes.id]] = posArr.concat([obj.children.length - 1]);
  //         data.splice(i, 1);
  //         i--;
  //       }
  //     }
  //     i++;
  //     if (i > data.length - 1) {
  //       i = 0;
  //     }
  //   }
  //   return tree;
  // },
  toTreeData:function(sNodes,attributes){
    debugger
    let r = [];
    let tmpMap = {};

    for (let i = 0, l = sNodes.length; i < l; i++) {
      let addObj = {id: sNodes[i][attributes.id],label: sNodes[i][attributes.name]} ;
      Object.assign(sNodes[i],addObj);
      tmpMap[sNodes[i][attributes['id']]] = sNodes[i];
    }

    for (let i = 0, l = sNodes.length; i < l; i++) {
      if (tmpMap[sNodes[i][attributes['pId']]] && sNodes[i][attributes['id']] != sNodes[i][attributes['pId']]) {
        if (!tmpMap[sNodes[i][attributes['pId']]]['children'])
          tmpMap[sNodes[i][attributes['pId']]]['children'] = [];
          tmpMap[sNodes[i][attributes['pId']]]['children'].push(sNodes[i]);
        } else {
          r.push(sNodes[i]);
        }
    }
    for (let i = 0, l = sNodes.length; i < l; i++){
      if(sNodes[i].sortNo && tmpMap[sNodes[i][attributes['id']]].children){
        tmpMap[sNodes[i][attributes['id']]].children.sort((a,b)=>{
          return a.sortNo - b.sortNo;
        })
      }
    }
    if(r[0].sortNo){
      r.sort((a,b)=>{
        return a.sortNo - b.sortNo;
      })
    }
      return r;
  },
  formatDate: function (val) {
    let value = new Date(val);
    let year = value.getFullYear();
    let month = this.padDate(value.getMonth() + 1);
    let day = this.padDate(value.getDate());
    let hour = this.padDate(value.getHours());
    let minutes = this.padDate(value.getMinutes());
    let seconds = this.padDate(value.getSeconds());
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
  },
  clearEmtryItemOfObject(obj){
    Object.keys(obj).forEach(key=>{
      if(!obj[key]||(obj[key]&&!obj[key].toString().trim())){
        delete obj[key];
      }
    })
  },
  showNotNull(obj){
    let _obj =  Object.assign({} , obj) ;
    Object.keys(_obj).forEach(key=>{
      if(_obj[key]==null ||_obj[key]=='undefined'){
        _obj[key] = "";
      }
    });
    return _obj;
  },
  //js计算丢失精度问题处理
  /* ** method **
 *  add / subtract / multiply /divide
 *
 * ** explame **
 *  0.1 + 0.2 == 0.30000000000000004 （多了 0.00000000000004）
 *  0.2 + 0.4 == 0.6000000000000001  （多了 0.0000000000001）
 *  19.9 * 100 == 1989.9999999999998 （少了 0.0000000000002）
 *
 * floatObj.add(0.1, 0.2) >> 0.3
 * floatObj.multiply(19.9, 100) >> 1990
 *
 */
  floatObj:(() =>{

    /*
     * 判断obj是否为一个整数
     */
    function isInteger(obj) {
      return Math.floor(obj) === obj;
    }

    /*
     * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
     * @param floatNum {number} 小数
     * @return {object}
     *   {times:100, num: 314}
     */
    function toInteger(floatNum) {
      let ret = {times: 1, num: 0};
      if (isInteger(floatNum)) {
        ret.num = floatNum;
        return ret
      }
      let strfi  = floatNum + '';
      let dotPos = strfi.indexOf('.');
      let len    = strfi.substr(dotPos+1).length;
      let times  = Math.pow(10, len);
      let intNum = parseInt(floatNum * times + 0.5, 10);
      ret.times  = times;
      ret.num    = intNum;
      return ret;
    }

    /*
     * 核心方法，实现加减乘除运算，确保不丢失精度
     * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
     *
     * @param a {number} 运算数1
     * @param b {number} 运算数2
     * @param digits {number} 精度，保留的小数点数，比如 2, 即保留为两位小数
     * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
     *
     */
    function operation(a, b, digits, op) {
      let o1 = toInteger(a);
      let o2 = toInteger(b);
      let n1 = o1.num;
      let n2 = o2.num;
      let t1 = o1.times;
      let t2 = o2.times;
      let max = t1 > t2 ? t1 : t2;
      let result = null;
      switch (op) {
        case 'add':
          if (t1 === t2) { // 两个小数位数相同
            result = n1 + n2
          } else if (t1 > t2) { // o1 小数位 大于 o2
            result = n1 + n2 * (t1 / t2)
          } else { // o1 小数位 小于 o2
            result = n1 * (t2 / t1) + n2
          }
          return result / max;
        case 'subtract':
          if (t1 === t2) {
            result = n1 - n2;
          } else if (t1 > t2) {
            result = n1 - n2 * (t1 / t2);
          } else {
            result = n1 * (t2 / t1) - n2;
          }
          return result / max;
        case 'multiply':
          result = (n1 * n2) / (t1 * t2);
          return result;
        case 'divide':
          result = (n1 / n2) * (t2 / t1);
          return result
      }
    }

    // 加减乘除的四个接口

    function add(a, b, digits) {
      return operation(a, b, digits, 'add');
    }
    function subtract(a, b, digits) {
      return operation(a, b, digits, 'subtract');
    }
    function multiply(a, b, digits) {
      return operation(a, b, digits, 'multiply');
    }
    function divide(a, b, digits) {
      return operation(a, b, digits, 'divide');
    }

    // exports

    return {
      add: add,
      subtract: subtract,
      multiply: multiply,
      divide: divide
    }
  })(),
  /**
   * 判断权限
   * @param permissionName
   * @returns {boolean}
   */
  getRolePermission(permissionName){
    return store.state.permissions.findIndex(item => {
      return item === permissionName;
    }) >= 0;
  },
  /**
   * 添加标签页
   * @param tab
   */
  addTab(tab){
    if(store.state.tabsArr.length >= 20){
      this.$message({
        type: "warning",
        message: "至多添加20个标签!"
      });
    }else{
      store.commit('ADD_TAB',tab);
    }
  },
  /**
   * 设置标签编辑内容处于已保存状态
   * @param tabId
   */
  setSaved(tabId){
    store.commit('SET_TAB_NO_SAVE_FALSE',tabId);
  },
  /**
   * 设置标签编辑内容处于未保存状态
   * @param tabId
   */
  setNoSave(tabId){
    store.commit('SET_TAB_NO_SAVE_TRUE',tabId);
  }
}



// WEBPACK FOOTER //
// ./src/service/common.js